// extracted by mini-css-extract-plugin
export default {"logo":"jh5qdK2RSzOSmvlSVU7N","logoLarge":"tZ0UrztGaiBmunwUtDZp"};